import React from 'react';
import styled from 'styled-components';
import { Layout, Hero, About, Jobs, Featured, Projects, Contact, SEO } from '@components';

const StyledMainContainer = styled.main`
  counter-reset: section;
`;

interface Props {
  location: {
    pathname: string;
    hash: string;
  };
}

const IndexPage: React.FC<Props> = ({ location }) => (
  <Layout location={location}>
    <StyledMainContainer className="fillHeight">
      <Hero />
      <About />
      <Jobs />
      <Featured />
      <Projects />
      <Contact />
    </StyledMainContainer>
  </Layout>
);

export default IndexPage;

export const Head = () => <SEO />;
